import { forEach } from '../polyfill/foreach.js';
import { classes } from '../constants';

export function setAttribute(els, attribute, value) {
  forEach(els, (index, el) => {
    el.setAttribute(attribute, value);
  });
}
export function setAttributes(el) {
  for (var i = 1; i < arguments.length; i += 2) {
    el.setAttribute(arguments[i], arguments[i + 1]);
  }
}
export function indexOf(group, target) {
  return Array.prototype.indexOf.call(group, target);
}
export function focusWithoutScrolling(el, hash) {
  let x, y;

  if (typeof window.pageXOffset !== 'undefined') {
    x = window.pageXOffset;
    y = window.pageYOffset;
  } else if (typeof window.scrollX !== 'undefined') {
    x = window.scrollX;
    y = window.scrollY;
  } else if (
    document.documentElement &&
    typeof document.documentElement.scrollLeft !== 'undefined'
  ) {
    x = document.documentElement.scrollLeft;
    y = document.documentElement.scrollTop;
  } else {
    x = document.body.scrollLeft;
    y = document.body.scrollTop;
  }

  el.focus();

  if (hash) {
    window.location.hash = el.id;
  }

  if (typeof x !== 'undefined') {
    window.scrollTo(x, y);
  }
}
export function setActive(all, el) {
  [...all].forEach(el => el.parentNode.classList.remove(classes.active));
  el.parentNode.classList.add(classes.active);
}
export function getAnchor(url) {
  return '#' + url.split('#')[1];
}
